import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import EducacaoService from '../../../../../services/contasEducacao-auth';



const ReceitaEducacao = () => {
    const [fonte, setFonte] = useState("");
    const [descricao, setDescricao] = useState("");
    const [data, setData] = useState("");
    const [valor, setValor] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const receita = await EducacaoService.cadastroReceita({
                fonte: fonte,
                valor: valor,
                descricao: descricao,
                data: data
            })
            if (receita.data["_id"]) {
                alert("Arrecadação cadastrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(receita.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setFonte("");
        setDescricao("");
        setData("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="fonte">
                                <FloatingLabel
                                    label="Fonte"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="fonte"
                                        value={fonte}
                                        onChange={e => setFonte(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Data">
                                <FloatingLabel
                                    label="Data"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data"
                                        value={data}
                                        onChange={e => setData(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="descricao">
                                <FloatingLabel
                                    label="Descrição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)} 
                                        as="textarea"
                                        rows={3}
                                        />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/educacao/receitas'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Arrecadação cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/educacao/receitas/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Arrecadações
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/educacao/receitas'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default ReceitaEducacao;